import { render, staticRenderFns } from "./HistorialConsumos.vue?vue&type=template&id=02aeacc9"
import script from "./HistorialConsumos.vue?vue&type=script&lang=js"
export * from "./HistorialConsumos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports